<template>
  <v-autocomplete
    hide-details="auto"
    :items="Place"
    :loading="loading"
    v-model="selectedPlace"
    item-text="name"
    item-value="id"
    label="Place"
    clearable
    outlined
    dense
    @change="emitInput"
    :search-input.sync="searchPlace"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    Place: [],
    selectedPlace: null,
    searchPlace:null,
    loading:false
  }),
  methods: {
    emitInput() {
      this.$emit("input", this.selectedPlace);
    },
    getPlaceByQuery(query = "") {
        
      this.loading = true;
      this.$store
        .dispatch("Places/Get", {
          query: query,
          status: "active",
        })
        .then((res) => {
          this.Place = res.data.data
          this.loading = false;

        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedPlace = null;
      },
      deep: true,
    },
    searchPlace: {
      handler(val) {
        this.getPlaceByQuery(val);
      },
      deep: true,
    },
  },
  created(){
    this.getPlaceByQuery()
  }
};
</script>